import React, { useState, useEffect } from "react";
import { Typography, FormControl, TextField } from "@mui/material";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";
import { updateProfile, hideError } from "../../redux/action";
import { allowedIdType } from "../../../utils/allowedIdType";
import { StepLabel, CustomButton, DefaultLoader } from "../../../components";
import styles from "../styles";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";

const UpdateCity = props => {
  const { loading, profile, updateProfile, history } = props;
  let format = /[a-zA-Z0-9\x20,.\-/&#@!$%^*~+]/;

  const [city, setCity] = useState("");
  const [isError, setIsError] = useState(false);

  const localIdentity = profile?.identities?.find(allowedIdType);

  useEffect(() => {
    if (profile) {
      setCity(
        profile?.contacts &&
          profile?.contacts.find(
            contact => contact.contactTypeCd === "PERMANENT"
          ).city
          ? profile?.contacts.find(
              contact => contact.contactTypeCd === "PERMANENT"
            ).city
          : ""
      );
    }
  }, [profile]);

  const handleChange = e => {
    const value = e.target.value;
    setCity(value);

    const isValid = value && Array.from(value).every(char => format.test(char));
    setIsError(!isValid);
  };

  const handleUpdate = () => {
    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: profile?.investmentObjCd,
      employerName: profile?.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        line2: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line2,
        line3: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line3,
        postCode: profile?.contacts.find(contact => contact.postCode).postCode, //R
        city: city, //R the updated
        state: profile?.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship,
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    updateProfile({ payloadData: payload, from: PROFILE });
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {loading && <DefaultLoader />}

      <StepLabel
        title="Update city"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <FormControl fullWidth style={{ marginBottom: "14px" }}>
          <Typography
            color="textPrimary"
            style={{ ...styles.baseFont, ...styles.inputLabel }}
          >
            City
          </Typography>
          <TextField
            placeholder="City"
            variant="outlined"
            fullWidth
            value={city}
            onChange={handleChange}
            error={isError}
            helperText={isError && "Invalid input name"}
            inputProps={{
              style: { ...styles.baseFont, padding: "12px 16px" },
            }}
            FormHelperTextProps={{
              style: { fontSize: "14px", marginLeft: "0px", color: "#be0712" },
            }}
          />
        </FormControl>
      </form>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Save"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={city && !isError ? false : true}
          onClick={handleUpdate}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
  }),
  {
    updateProfile,
    hideError,
  }
);

export default compose(
  withRouter,
  withConnect
)(UpdateCity);
